import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class JobFullDetailsToolsButtonsMarkUnmarkJobAsVehicleOnSite extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      hasSplitParent: this.props.hasSplitParent || false,
      isSplitJob: this.props.isSplitJob || false,
      hasSplitJobs: this.props.hasSplitJobs || false,
      isSplitJobPartA: this.props.isSplitJobPartA || false,
      isSplitJobPartB: this.props.isSplitJobPartB || false,
      apiUrlForToggleMarkJobAsVehicleOnSite: "/api/v1/portal/jobs/mark-as/toggle/vehicle-on-site/",
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }
  toggleMarkJobAsVehicleOnSite() {
    return fetch(
      this.state.apiUrlForToggleMarkJobAsVehicleOnSite+
      this.state.data.id,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        },
      }
    ).then((responseText) => {
      }
    );
  }

  render() {
    return(
      <span> {(!this.state.data.vehicle_on_site ||
        this.state.data.vehicle_on_site === 0) ?
        <p></p>
        :
        <p>
          <button className="btn btn-lg btn-outline-success">
            Vehicle On Site (by {
            this.state.data.vehicle_on_site_marked_by.first_name
          }&nbsp;{this.state.data.vehicle_on_site_marked_by.last_name
          } on {this.state.data.vehicle_on_site_at})
          </button>&nbsp;
          <button
            className="btn btn-lg btn-dark job-row-highlighter-option-green"
            onClick={(e) => this.toggleMarkJobAsVehicleOnSite(e)}
          >
            <i className="fa fa-undo"></i>&nbsp;
            Unmark Job as Vehicle On Site
          </button>
        </p>
      }
    </span>
    )
  }
}